import React from "react"
import LaunchHero from "../components/launch/LaunchHero.jsx"
import PromoCounter from "../components/launch/PromoCounter.jsx"
import LaunchPricing from "../components/launch/LaunchPricing.jsx"
import WhatItDoes from "../components/WhatItDoes.jsx"
import HowItWorks from "../components/HowItWorks.jsx"
import Faq from "../components/Faq.jsx"
import usePromoCounter from "../hooks/usePromoCounter.js"

// Launch promo view — scarcity-framed alternative to the standard
// HomeView, mounted by App.jsx when data-page="launch". Same chrome
// (Header / Footer come from App.jsx), promo-specific sections in
// the middle, standard WhatItDoes + HowItWorks + Faq reused below.
//
// Initial spotsRemaining / spotsTotal come from the server-rendered
// HAML data attributes so the page renders correct values on first
// paint. usePromoCounter then keeps them fresh while the visitor is
// on the page — the count ticks down visibly as new shops sign up.
export default function LaunchView({ priceCents = 9900, promoCode = "SAVE50", spotsRemaining, spotsTotal = 100 }) {
  const live = usePromoCounter(promoCode, { spotsRemaining, spotsTotal, status: "open" })

  const remaining = typeof live.spotsRemaining === "number" ? live.spotsRemaining : spotsRemaining
  const total = live.spotsTotal || spotsTotal
  const closed = live.status === "closed" || (typeof remaining === "number" && remaining <= 0)

  return (
    <>
      <LaunchHero promoCode={promoCode} spotsRemaining={remaining} spotsTotal={total} />
      <PromoCounter spotsRemaining={remaining} spotsTotal={total} status={live.status} />
      <WhatItDoes />
      <HowItWorks />
      <LaunchPricing priceCents={priceCents} closed={closed} />
      <Faq />
    </>
  )
}
